import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import { ArrowLeft, ArrowRight, Linkedin } from "lucide-react";
import { useTranslation } from "react-i18next";
import leventImg from "@/assets/levent.jpg";
import { FounderJsonLd } from "@/components/JsonLd";

const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <PageMeta
        title="About — rawResponse {Labs}"
        description="rawResponse {Labs} is the research lab behind webblitz.ai — building the infrastructure that powers AI visibility for agencies and enterprises."
      />
      <FounderJsonLd />
      <Navbar />

      <main className="pt-24 pb-20">
        <div className="container max-w-4xl">
          <a
            href="/"
            className="inline-flex items-center gap-1.5 text-[13px] font-mono text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft size={14} />
            {t("about.back")}
          </a>

          <h1 className="text-3xl md:text-4xl font-mono font-bold mb-4">{t("about.title")}</h1>
          <p className="text-[14px] font-mono text-muted-foreground leading-relaxed max-w-2xl mb-16">
            {t("about.description")}
          </p>

          <div className="section-divider w-full mb-12" />

          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-[11px] font-mono text-primary mb-3 tracking-widest uppercase">
                {t("about.founderLabel")}
              </p>
              <h2 className="text-2xl md:text-3xl font-mono font-bold mb-5">{t("about.founderName")}</h2>
              <p className="text-[14px] font-mono text-muted-foreground leading-relaxed mb-4">
                {t("about.founderBio1")}
              </p>
              <p className="text-[14px] font-mono text-muted-foreground leading-relaxed mb-6">
                {t("about.founderBio2")}
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://linkedin.com/in/levo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 h-9 px-4 rounded-md border border-border text-[13px] font-mono text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors"
                >
                  <Linkedin size={14} />
                  {t("about.linkedIn")}
                </a>
                <a
                  href="https://valente.ventures"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary text-primary-foreground text-[13px] font-mono font-medium hover:bg-primary/90 transition-colors"
                >
                  valente.ventures
                  <ArrowRight size={13} />
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="rounded-lg overflow-hidden card-glow">
                <img
                  src={leventImg}
                  alt="Levent Valente — Founder of rawResponse {Labs}"
                  className="w-full h-auto object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
